type OrderByDirection = 'asc' | 'desc'

export const isEmpty = (obj: any) => {
  const hasOwnProperty = Object.prototype.hasOwnProperty
  if (obj == null) return true
  if (obj.length > 0) return false
  if (obj.length === 0) return true
  if (typeof obj !== 'object') return true
  for (const key in obj) {
    if (hasOwnProperty.call(obj, key)) return false
  }
  return true
}

export const isEqual = (ObjA: any, ObjB: any) => {
  let leftChain: any[] = [],
    rightChain: any[] = []

  function compare2Objects(x: any, y: any) {
    let p
    if (isNaN(x) && isNaN(y) && typeof x === 'number' && typeof y === 'number') return true
    if (x === y) return true
    if (
      (typeof x === 'function' && typeof y === 'function') ||
      (x instanceof Date && y instanceof Date) ||
      (x instanceof RegExp && y instanceof RegExp) ||
      (x instanceof String && y instanceof String) ||
      (x instanceof Number && y instanceof Number)
    )
      return x.toString() === y.toString()
    if (!(x instanceof Object && y instanceof Object)) return false
    if (Object.prototype.isPrototypeOf.call(x, y) || Object.prototype.isPrototypeOf.call(y, x)) return false
    if (x.constructor !== y.constructor) return false
    if (x.prototype !== y.prototype) return false
    if (leftChain.indexOf(x) > -1 || rightChain.indexOf(y) > -1) return false
    for (p in y) {
      if (Object.prototype.hasOwnProperty.call(y, p) !== Object.prototype.hasOwnProperty.call(x, p)) return false
      else if (typeof y[p] !== typeof x[p]) return false
    }
    for (p in x) {
      if (Object.prototype.hasOwnProperty.call(y, p) !== Object.prototype.hasOwnProperty.call(x, p)) return false
      else if (typeof y[p] !== typeof x[p]) return false
      switch (typeof x[p]) {
        case 'object':
        case 'function':
          leftChain.push(x)
          rightChain.push(y)
          if (!compare2Objects(x[p], y[p])) return false
          leftChain.pop()
          rightChain.pop()
          break
        default:
          if (x[p] !== y[p]) return false
          break
      }
    }
    return true
  }
  leftChain = []
  rightChain = []
  if (!compare2Objects(ObjA, ObjB)) return false
  return true
}
export function orderBy<T>(
  collection: T[],
  iteratees: ((item: T) => any)[] | ((item: T) => any),
  orders: OrderByDirection[] | OrderByDirection = 'asc'
): T[] {
  // Chuyển đổi iteratees và orders thành mảng nếu chúng không phải là mảng
  const iterateesArray = Array.isArray(iteratees) ? iteratees : [iteratees]
  const ordersArray = Array.isArray(orders) ? orders : [orders]

  // Sử dụng slice để sao chép mảng gốc và không ảnh hưởng đến nó
  const clonedCollection = collection.slice()

  // Sắp xếp mảng dựa trên các iteratees và orders
  clonedCollection.sort((a, b) => {
    for (let i = 0; i < iterateesArray.length; i++) {
      const iteratee = iterateesArray[i]
      const order = ordersArray[i] || 'asc'

      const aValue = iteratee(a)
      const bValue = iteratee(b)

      if (aValue < bValue) {
        return order === 'asc' ? -1 : 1
      }
      if (aValue > bValue) {
        return order === 'asc' ? 1 : -1
      }
    }
    return 0
  })

  return clonedCollection
}

export const inRange = (number: number, start: number, end: number, inclusive = true): boolean => {
  if (inclusive) {
    return number >= Math.min(start, end) && number <= Math.max(start, end)
  } else {
    return number > Math.min(start, end) && number < Math.max(start, end)
  }
}

export function round(number: number, precision = 0): number {
  const multiplier = Math.pow(10, precision)
  return Math.round(number * multiplier) / multiplier
}

export function throttle<T extends (...args: any[]) => void>(
  func: T,
  wait: number,
  options?: { leading?: boolean; trailing?: boolean }
): T {
  let timeout: NodeJS.Timeout | null
  let previous = 0

  const throttled = function (this: any, ...args: any[]) {
    const now = Date.now()
    if (!previous && options?.leading === false) {
      previous = now
    }
    const remaining = wait - (now - previous)

    if (remaining <= 0 || remaining > wait) {
      if (timeout) {
        clearTimeout(timeout)
        timeout = null
      }
      previous = now
      func.apply(this, args)
    } else if (!timeout && options?.trailing !== false) {
      timeout = setTimeout(() => {
        previous = options?.leading === false ? 0 : Date.now()
        func.apply(this, args)
        timeout = null
      }, remaining)
    }
  } as T

  return throttled
}

export const debounce = (fn: () => void, ms = 300) => {
  let timeoutId: ReturnType<typeof setTimeout>
  return function () {
    clearTimeout(timeoutId)
    timeoutId = setTimeout(fn, ms)
  }
}

export const isJson = (str: string) => {
  try {
    JSON.parse(str)
  } catch (e) {
    return false
  }
  return true
}

export const getParamFromURL = (param: string) => {
  const urlParams = new URLSearchParams(window.location.search)
  return urlParams.get(param)
}
export const getDifference = (a: any, b: any) =>
  Object.fromEntries(Object.entries(b).filter(([key, val]) => key in a && a[key] !== val))
